import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

import Filters from '../components/filters';
import {ROUTES} from '../config';

export default withRouter(
	connect(
		(state) => ({
			showSearchOnly: !!(
				state.app.isFocusOnSearch || state.app.searchTerm
			),
			previousLocationPath: state.app.previousLocation?.pathname,
		}),
		undefined,
		({showSearchOnly, previousLocationPath}, {dispatch}, ownProps) => {
			const willReset = ownProps.location.pathname === ROUTES.LIST.path;

			return {
				showSearchOnly,
				...ownProps,
				willReset,
				reset: () => {
					if (willReset) {
						if (showSearchOnly) {
							dispatch({
								type: 'SET_SEARCH',
								isFocusOnSearch: false,
								searchTerm: '',
							});
						} else {
							dispatch({type: 'RESET_APP_STATE'});
						}
					} else {
						if (previousLocationPath === ROUTES.LIST.path) {
							ownProps.history.goBack();
						} else {
							ownProps.history.push(ROUTES.LIST.path);
						}
					}
				},
			};
		}
	)(Filters)
);
